module.exports = __webpack_public_path__ + "static/img/defaultAvatar.c231fa1.png";